// STOMP でストリーミング配信されるトークンのペイロード。
export type TokenStreamedPayload = { text: string; index: number }

// トークンは並列配信で順不同に届くため、index 順に結合して本文を復元する。
export const combineTokenChunks = (chunks: TokenStreamedPayload[]): string =>
  [...chunks]
    .sort((a, b) => a.index - b.index)
    .map(chunk => chunk.text)
    .join('')
